<ng-container *ngIf="content?.showInProduction">
  <a class="btn btn-primary" [routerLink]="content?.linkUrl">{{content?.linkTitle}}</a>
</ng-container>
